module.exports = __webpack_public_path__ + "img/30600.a0acd7cd.jpg";